import { Asset } from '@/interfaces/models/Asset';

const EMPTY_ASSET: Asset = { thumb: '', medium: '', large: '', original: '' };

/**
 * Resolves the `image` value a provider settings form should submit on save.
 *
 * The article/option-article update replaces the whole `externalOrderProviderSettings`
 * array, so an omitted image is lost. The value must therefore always be explicit:
 * - a newly picked File is kept (the dedicated upload endpoint stores it afterwards),
 * - an explicit removal yields an empty asset (aggregators fall back to the default image),
 * - an untouched existing image is preserved,
 * - otherwise there is no image to send and the field is dropped.
 */
export function resolveProviderImageForSave(
  currentValue: File | Asset | null | undefined,
  existingImage: Asset | undefined,
  removed: boolean,
): File | Asset | undefined {
  if (currentValue instanceof File) {
    return currentValue;
  }

  if (removed) {
    return existingImage?.thumb ? { ...EMPTY_ASSET } : undefined;
  }

  return existingImage;
}
